export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY="2365b4f588ff705929c3e8c3ce1c5e72";
export const imageUrl = "https://image.tmdb.org/t/p/original"

